<div
  @showHide
  class="cb-notification-wrapper"
  [ngClass]="[
    'cb-hierarchy-' + hierarchy(),
    'cb-color-' + color(),
    'cb-direction-' + direction(),
  ]"
>
  @if (image() && imageStyle() == "thumbnail") {
    <div class="cb-notification-preview">
      <div
        class="cb-notification-thumbnail"
        [style.backgroundImage]="'url(' + image() + ')'"
      ></div>
    </div>
  }
  <div class="cb-notification-container">
    <div class="cb-notification-header">
      <div
        class="cb-notification-icon"
        [class.cb-custom-icon]="icon() != undefined && icon().length > 0"
      >
        @if (icon() && icon().length > 0) {
          <cb-icon [name]="icon()"></cb-icon>
        } @else {
          <cb-featured-icon
            [name]="currentIcon()"
            size="sm"
            [type]="currentIconType()"
            [color]="color()"
          ></cb-featured-icon>
        }
      </div>
      @if (showCloseButton()) {
        <div class="cb-notification-close-button">
          <cb-button
            (click)="closeClicked.emit()"
            type="iconOnly"
            hierarchy="tertiary"
            color="gray"
            size="xs"
            icon="cb-base-outline-close"
          ></cb-button>
        </div>
      }
    </div>
    <div class="cb-notification">
      <div class="cb-notification-title">
        @if (useInnerHtml()) {
          <h6 [innerHTML]="title()"></h6>
        } @else {
          <h6>{{ title() }}</h6>
        }

        @if (createdAt()) {
          <span>{{ createdAt() | date: "HH:mm" }}</span>
        }
      </div>
      @if (message()) {
        @if (useInnerHtml()) {
          <p [innerHTML]="message()"></p>
        } @else {
          <p>{{ message() }}</p>
        }
      }
    </div>
    @if (image() && imageStyle() == "preview") {
      <div class="cb-notification-image-container">
        <div
          class="cb-notification-image"
          [style.backgroundImage]="'url(' + image() + ')'"
        ></div>
      </div>
    }
    <div class="cb-notification-actions">
      @for (action of actions(); track $index) {
        <button
          (click)="action.callback()"
          [ngClass]="'cb-color-' + action.color"
          class="cb-notification-action"
        >
          <p>{{ action.label | translate }}</p>
        </button>
      }
    </div>
  </div>
</div>
